import React from 'react';
import { DateTypeSelect, MaskInput, TimeInput } from 'components';
import { inputTypeEnums } from '../../attributes/constnats';
import { useMentionOptions } from './useMentionOptions';
import { MentionableInput } from './mentionableInput';

export const InputElement = ({ item, value, onChange, readOnly, noMentions, activeSection }) => {
    const currentModelEnums = useMentionOptions({ noMentions, activeSection, goalMode: !!item?.properties?.goalMode });

    const handleMentionChange = (html) => {
        onChange(html);
    };

    return (
        <>
            {item?.defaultDateType === inputTypeEnums.PHONE && (
                <div className="form-phone-number">
                    <MaskInput
                        name={item?.item}
                        value={value || ''}
                        handleChange={(e) => onChange(e.target.value.replace(/[() -]/g, ''))}
                        disabled={readOnly}
                        uiType="uiType"
                        noErrorMessage={true}
                    />
                </div>
            )}

            {item?.defaultDateType === inputTypeEnums.EMAIL && (
                <input
                    className="form-input-box"
                    type="email"
                    name={item?.item}
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={readOnly}
                    placeholder={item?.placeholder || ''}
                />
            )}

            {item?.defaultDateType === inputTypeEnums.NUMBER && (
                <input
                    className="form-input-box"
                    type="number"
                    name={item?.item}
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={readOnly}
                    placeholder={item?.placeholder || ''}
                />
            )}

            {item?.defaultDateType === inputTypeEnums.TEXT && (
                <div className="mention-wrapper">
                    <MentionableInput
                        className="mention-input"
                        defaultValue={value}
                        onChange={handleMentionChange}
                        readOnly={readOnly}
                        mentionOptions={currentModelEnums || []}
                        singleLine
                        noError={true}
                        placeholder={item?.placeholder}
                    />
                </div>
            )}

            {item?.defaultDateType === inputTypeEnums.DATE && (
                <DateTypeSelect
                    name={item?.item}
                    handleGetDates={(e) => onChange(e.target.value)}
                    values={{ [item?.item]: value }}
                    noError={true}
                />
            )}

            {item?.defaultDateType === inputTypeEnums.TIME && (
                <TimeInput
                    customClass={'form-time-input'}
                    name={item?.item}
                    onChange={(e) => onChange(e.target.value)}
                    defaultValue={value ? value?.slice(11, 16) || value : null}
                    errorFalse={true}
                />
            )}
        </>
    );
};
